<template>
  <div>
      <div style="background-color: rgb(255, 255, 255);">
        <!-- <el-row direction="horizontal" style="margin-top: 10px;">
          <el-col :span="8">
            <el-card :style="{ 'margin-left': '10px', 'width': '210px', 'background-color': regularColor }"
              @click.native="cardClick('常规随访')">
              <div>
                <el-statistic :value="overviewData1.value" :title="overviewData1.title"
                  :value-style="{ color: 'cornflowerblue' }">
                  <template slot="prefix">
                    <i class="el-icon-s-flag" style="color: cornflowerblue"></i>
                  </template>
                </el-statistic>
              </div>
            </el-card>
          </el-col>

          <el-col :span="8">
            <el-card :style="{ 'margin-left': '10px', 'width': '210px', 'background-color': previewColor }"
              @click.native="cardClick('诊前随访')">
              <div>
                <el-statistic :value="overviewData2.value" :title="overviewData2.title"
                  :value-style="{ color: 'cornflowerblue' }">
                  <template slot="prefix">
                    <i class="el-icon-s-flag" style="color: cornflowerblue"></i>
                  </template>
                </el-statistic>
              </div>
            </el-card>
          </el-col>

          <el-col :span="8">
            <el-card :style="{ 'margin-left': '10px', 'width': '210px', 'background-color': afterColor }"
              @click.native="cardClick('诊后随访')">
              <div>
                <el-statistic :value="overviewData3.value" :title="overviewData3.title"
                  :value-style="{ color: 'cornflowerblue' }">
                  <template slot="prefix">
                    <i class="el-icon-s-flag" style="color: cornflowerblue"></i>
                  </template>
                </el-statistic>
              </div>
            </el-card>
          </el-col>
        </el-row> -->

        <el-row style="margin-top: 20px;">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="当日到期需随访" name="first"></el-tab-pane>
            <el-tab-pane label="三天内到期需随访" name="second"></el-tab-pane>
            <el-tab-pane label="已过期随访" name="third"></el-tab-pane>
            <el-tab-pane label="已完成随访" name="four"></el-tab-pane>
          </el-tabs>
        </el-row>

        <el-row>
          <!-- <table-detail :activeName="activeName"></table-detail> -->
          <div>
            <el-form :model="listQuery" :inline="true" style="margin-top: 20px;margin-left: 20px">
              <!-- <el-form-item label="机构">
                <patientTree @input="input"></patientTree>
              </el-form-item> -->

              <el-form-item label="姓名">
                <el-input v-model="listQuery.patientName"></el-input>
              </el-form-item>

              <el-form-item label="随访类别" style="margin-left: 20px;">
                <el-select v-model="listQuery.type" placeholder="请选择">
                  <!-- <el-option label="全部" :value="null"></el-option> -->
                  <el-option label="常规随访" :value="null"></el-option>
                  <el-option label="诊前随访" value="诊前随访"></el-option>
                  <el-option label="诊后随访" value="诊后随访"></el-option>
                </el-select>
              </el-form-item>

              <!-- <el-form-item label="规范管理">
                <el-select v-model="listQuery.isDiabetStdManage" placeholder="请选择">
                  <el-option label="全部" :value="null"></el-option>
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item> -->

              <!-- <el-form-item v-if="timeVisiable" label="随访时间">
                <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
              </el-form-item>
            </el-form>

            <el-table v-loading="listLoading" :data="list" border fit highlight-current-row
              style="width: 100%; margin-top: 20px">

              <el-table-column width="100px" align="center" label="姓名">
                <template slot-scope="scope">
                  <span>{{ scope.row.patientName }}</span>
                </template>
              </el-table-column>

              <el-table-column width="200px" align="center" label="身份证号">
                <template slot-scope="scope">
                  <span>{{ scope.row.idcard }}</span>
                </template>
              </el-table-column>

              <el-table-column width="100px" align="center" label="性别">
                <template slot-scope="scope">
                  <span>{{ getGender(scope.row.gender) }}</span>
                </template>
              </el-table-column>

              <el-table-column width="100px" align="center" label="年龄">
                <template slot-scope="scope">
                  <span>{{ getAge(scope.row.birthday) }}</span>
                </template>
              </el-table-column>

              <!-- <el-table-column width="150px" align="center" label="电话号码">
                <template slot-scope="scope">
                  <span>{{ scope.row.phone }}</span>
                </template>
              </el-table-column> -->

              <el-table-column width="150px" align="center" label="随访时间">
                <template slot-scope="scope">
                  <span>{{ getParsedTime(scope.row.startTime) }}</span>
                </template>
              </el-table-column>

              <!-- <el-table-column width="150px" align="center" label="所属机构">
                <template slot-scope="scope">
                  <span>{{ scope.row.managerHospital }}</span>
                </template>
              </el-table-column> -->

              <!-- <el-table-column width="150px" align="center" label="规范管理">
                <template slot-scope="scope">
                  <span>{{ scope.row.isDiabetStdManage }}</span>
                </template>
              </el-table-column> -->

              <el-table-column width="150px" align="center" label="责任医师">
                <template slot-scope="scope">
                  <span>{{ scope.row.doctorResponse }}</span>
                </template>
              </el-table-column>

              <el-table-column fixed="right" align="center" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button v-if="buttonVisiable" style="margin-left: 0px; align-self: center" type="text"
                    @click="editFollowUp(scope.row)">
                    随访
                  </el-button>

                  <!-- <el-button style="margin-left: 10px; align-self: center" type="text" @click="onDetail(scope.row)">
                详情
              </el-button> -->

                  <el-button style="margin-left: 10px; align-self: center" type="text"
                    @click="patientsDetail(scope.row)">
                    健康档案
                  </el-button>

                  <!-- <el-button style="margin-left: 10px; align-self: center" type="text" @click="onDelete(scope.row)">
                    删除
                  </el-button> -->
                </template>
              </el-table-column>
            </el-table>

            <pagination v-show="total > 0" :total="total" :page.sync="formData.pageNum" :limit.sync="formData.pageSize"
              @pagination="turnToPage" />

            <blood-edit-follow-up v-if="editFollowUpVisible" ref="EditFollowUpRef"
              @addEventPlan="getList"></blood-edit-follow-up>
            <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>

            <consultationRecordDialog v-if="consultationRecordVisible" ref="consultationRecordRef"></consultationRecordDialog>

          </div>
        </el-row>
      </div>
    </div>
</template>

<script>
import {
  getListByTime,
  delPatientFollowupRecord,
  getFollowupValue,
  getUserInfos,
  turnToListByTime,
  getSearchList,
  getFollowupTips,
  getSysDicList
} from "@/api/health/Patients.js"
import bloodFollowUpDetail from "./bloodFollowUpDetail.vue";
import Pagination from "@/components/Pagination";
import patientTree from '@/components/selectTree';
import bloodEditFollowUp from "./bloodEditFollowUp.vue";
import patientDetail from "@/views/patient/patientDetail";
import consultationRecordDialog from "../collaborativeManagement/bloodGlucoseCollaborative/glucoseRecordDialogs/consultationRecordDialog.vue";

import moment from "moment";
import { color } from "echarts";

export default {
  components: { bloodFollowUpDetail, bloodEditFollowUp, patientTree, Pagination, patientDetail, consultationRecordDialog },
  data() {
    return {
      activeName: "first",
      editFollowUpVisible: false,
      // followUpDetailVisible: false,
      patientDetailVisible: false,
      consultationRecordVisible: false,
      listLoading: false,
      list: [],
      time: [],
      total: 0,
      listQuery: {
        startTime: null,
        endTime: null,
        doctorResponse: null,
        filterExpired: null,
        isDiabetStdManage: null,
        managerHospitals: [],
        patientName: null,
        status: '未随访',
        idcard: null,
        serviceName: '高血脂随访',
        type: null
      },
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      followUpTipsQuery: {
        serviceName: '高血脂随访'
      },
      buttonVisiable: true,
      timeVisiable: false,
      data: [],
      valueData: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      overviewData1: {
        value: 0,
        title: "常规随访",
      },
      overviewData2: {
        value: 0,
        title: "诊前随访",
      },
      overviewData3: {
        value: 0,
        title: "诊后随访",
      },
      regularColor: '#ECF5FF',
      previewColor: '#ffffff',
      afterColor: '#ffffff',
      currentType: null,
      sexOptions: [],
    };
  },
  created() {
    var typeData = "性别";
    this.getSystemDictList(typeData);

    this.getList();
    this.getFollowupTipsMethod();
  },
  methods: {
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sexOptions = records;
      }).catch(err => {
        console.log(err);
      })
    },
    getFollowupTipsMethod() {
      getFollowupTips(this.followUpTipsQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          var data = res.data[0];
          this.overviewData1.value = data.countFollowupRegular;
          this.overviewData2.value = data.countFollowupBeforeVisit;
          this.overviewData3.value = data.countFollowupAfterVisit;
        }
      }).catch(error => {
        console.log(error);
      });
    },
    cardClick(type) {
      if (type == '常规随访') {
        this.regularColor = '#ECF5FF';
        this.previewColor = '#ffffff';
        this.afterColor = '#ffffff';
        this.currentType = null;
      } else if (type == '诊前随访') {
        this.regularColor = '#ffffff';
        this.previewColor = '#ECF5FF';
        this.afterColor = '#ffffff';
        this.currentType = '诊前随访';
      } else if (type == '诊后随访') {
        this.regularColor = '#ffffff';
        this.previewColor = '#ffffff';
        this.afterColor = '#ECF5FF';
        this.currentType = '诊后随访';
      }
    },
    // 点击切换tab标签页事件
    handleClick(target, action) {
      console.log(target.name, action)
      this.activeName = target.name;

      var newValue = target.name;
      if (newValue == "first") {
        this.listQuery = {
          patientName: null,
          isDiabetStdManage: null,
          managerHospitals: [],
          doctorResponse: null,
          filterExpired: false,
          startTime: this.getSystemTime(),
          endTime: this.getRecentDay(-1),
          status: "未随访",
          idcard: null,
          serviceName: '高血脂随访',
          type: null
        };
        this.buttonVisiable = true;
        this.timeVisiable = false;
      } else if (newValue == "second") {
        this.listQuery = {
          patientName: null,
          isDiabetStdManage: null,
          managerHospitals: [],
          doctorResponse: null,
          filterExpired: false,
          startTime: this.getSystemTime(),
          endTime: this.getRecentDay(-3),
          status: "未随访",
          idcard: null,
          serviceName: '高血脂随访',
          type: null
        };
        this.buttonVisiable = true;
        this.timeVisiable = false;
      } else if (newValue == "third") {
        this.listQuery = {
          patientName: null,
          isDiabetStdManage: null,
          managerHospitals: [],
          doctorResponse: null,
          filterExpired: true,
          startTime: null,
          endTime: null,
          status: "未随访",
          idcard: null,
          serviceName: '高血脂随访',
          type: null
        };
        this.buttonVisiable = true;
        this.timeVisiable = true;
      } else if (newValue == "four") {
        this.listQuery = {
          patientName: null,
          managerHospitals: [],
          isDiabetStdManage: null,
          doctorResponse: null,
          filterExpired: false,
          startTime: null,
          endTime: null,
          status: "已完成",
          idcard: null,
          serviceName: '高血脂随访',
          type: null
        };
        this.buttonVisiable = false;
        this.timeVisiable = true;
      }
      this.$nextTick(() => {
        this.getList(this.listQuery)
      })
    },
    getList(params) {
      this.list = [];
      this.listLoading = true;
      if (this.valueData && this.timeVisiable) {
        this.listQuery.startTime = this.valueData != [] ? this.getParseDate(this.valueData[0], 1) : null;
        this.listQuery.endTime = this.valueData != [] ? this.getParseDate(this.valueData[1], 2) : null;
      } else if (!this.valueData && this.timeVisiable) {
        this.listQuery.startTime = null;
        this.listQuery.endTime = null;
      }

      this.listQuery.serviceName = '高血脂随访';

      params = this.listQuery;
      getListByTime(params).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.total = res.data.total;
          this.list = res.data.records;
          this.list.sort(function (a, b) {
            return b.createDate < a.createDate ? -1 : 1;
          });
        }
      }).catch(error => {
        console.log(error);
        this.listLoading = false;
      });
    },
    // 导航跳转查询列表页
    turnToPage() {
      let params = Object.assign({}, this.listQuery, this.formData)
      this.listLoading = true;
      turnToListByTime(params).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.list = res.data.records;
          this.list.sort(function (a, b) {
            return b.createDate < a.createDate ? -1 : 1;
          });
          this.total = res.data.total;
        }
      });
    },
    // 日期格式转化
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
    // 获取机构数组
    input(value) {
      this.listQuery.managerHospitals = value;
    },
    editFollowUp(row) {
      if (row.followupFlag != null) {
        //诊前随访
        this.consultationRecord(row);
      } else if (row.refollowFlag != null) {
        //诊后随访
        this.consultationRecord(row);
      } else {
        //常规随访
        this.onEdit(row);
      }
    },
    //处置回访
    consultationRecord(data) {
      this.consultationRecordVisible = true;
      this.$nextTick(() => {
        this.$refs.consultationRecordRef.init(data);
      });
    },
    onEdit(row) {
      row["pInfo"] = this.pInfo;
      let params = {
        idcard: row.idcard,
        serviceType: "高血脂"
      }
      var data = {
        idcard: row.idcard,
        status: "已完成"
      }

      getFollowupValue(params).then(res => {
        if (res.msg == "success") {
          if (res.data) {
            row.bloodSuger = res.data.bloodSuger;
            row.nextFollowupTime = res.data.nextFollowupTime;
            row.bloodsugarTime = res.data.startTime;
            getListByTime(data).then(Response => {
              if (Response.msg == "success") {
                const data = Object.assign({}, Response.data);
                if (data.hasOwnProperty("records") && data.records.length != 0) {
                  Response.data.records = Response.data.records.filter((item) => {
                    return item.status == "已完成";
                  });
                  row.records = Response.data.records[0];
                  row.records.startTime = row.startTime;
                  row.records.scheduleTime = row.scheduleTime;
                }
                this.editFollowUpVisible = true;
                this.$nextTick(() => {
                  this.$refs["EditFollowUpRef"].init(row);
                });
              }
            }).catch((error) => {
              console.log(error);
            })
          } else {
            this.$message({
              message: "该患者暂无最新数据，请获取最新数据！",
              type: "error"
            })
          }
        }
      }).catch(error => {
        console.log(error);
      })
    },
    // 跳转至相应病人档案详情页
    patientsDetail(row) {
      // let params = {
      //   healthNo: row.healthNo
      // }
      // getSearchList(params).then((res) => {
      //   if (res.msg == "success") {
      //     console.log("========", res, row)
      //     var data = res.data.records[0];
      //     this.patientDetailVisible = true;
      //     this.$nextTick(() => {
      //       this.$refs["PatientDetailRef"].init(data);
      //     });
      //   }
      // }).catch((error) => {
      //   console.log(error);
      // })

      this.patientDetailVisible = true;
      this.$nextTick(() => {
        this.$refs["PatientDetailRef"].init(row);
      });
    },
    onDelete(row) {
      this.$confirm("此操作将删除该随访信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const patientData = {
            id: row.id,
          };
          this.listLoading = true;
          delPatientFollowupRecord(patientData).then((res) => {
            this.listLoading = false;
            if (res.msg == "success") {
              this.$message({
                message: "删除成功！",
                type: "success",
              });
              // 更新视图列表
              this.getList(this.listQuery);
            } else {
              this.$message({
                message: "删除失败！",
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    deleteFollowUp(followUpId) {
      this.deleteFollowUpParam.id = followUpId;
      deleteFollowUp(this.deleteFollowUpParam).then((res) => {
        console.log(res);
      });
    },
    getSystemTime() {
      var date = new Date();
      var y = date.getFullYear()
      var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      var startTime = y + "-" + m + "-" + d;
      console.log(startTime);
      return startTime;
    },
    getRecentDay(n) {
      let day = moment(new Date()).subtract(n, "days").format("YYYY-MM-DD");
      console.log(day);
      return day;
    },
    getGender(gender) {
      var option = this.sexOptions.filter(v => v.value == gender)[0];
      return option.name;
    },
    getParsedTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
    // 计算当前年龄
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
  }
};
</script>

<style lang="scss" scoped>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 10px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
}

.form ::v-deep {
  .el-form-item {
    display: inline-flex;
  }

  .el-input--medium .el-input__inner {
    width: 209px !important;
  }

  .el-form-item__content {
    margin-left: 10px !important;
  }
}
</style>